import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SystemInformationService } from '../SystemInformation/SystemInformationService';
import { Subscription } from 'rxjs';
import { isTruthy } from '../objectUtils';


@Injectable({
  providedIn: "root"
})
export class LogService  {

  toLog: boolean = true;
  mainSubscription: Subscription = new Subscription();
  constructor(private http: HttpClient, private env: SystemInformationService) {
    this.mainSubscription.add(
      this.env.envSettingsBS.subscribe(res => {
        if (res.logFromFrontend != undefined) { 
          this.toLog = isTruthy(res.logFromFrontend);
        }
      })
    );
  }


  public logToBackend(logModel: models.LogModelVM) {
    if (this.toLog) {
      this.http.post<boolean>('api/Log/LogFromFrontEnd', logModel)
        .subscribe((result) => {
          if (result) {
            console.log(`Log sent to backend, message: ${logModel.message}
                      - type: ${logModel.type}`);
          }
      }, error => console.error(error));
    }
  }

}
